import { createBehavior } from '@area17/a17-behaviors';

const randomimage = createBehavior(
  'randomimage',
  {},
  {
    init() {
      const items = Array.from(this.getChildren('item') ?? []);
      const randomItem = items[Math.floor(Math.random() * items.length)];
      randomItem.style.display = '';
    },
    destroy() {},
  }
);

export default randomimage;
